import type { PropertiesTab, PropertyPageMode } from '../types';

export const PROPERTY_TITLES: Record<PropertiesTab, Record<PropertyPageMode, string>> = {
	properties: {
		add: 'Nova Propriedade',
		edit: 'Editar Propriedade',
		view: 'Informações da Propriedade',
	},
	areas: {
		add: 'Nova Área',
		edit: 'Editar Área',
		view: 'Informações da Área',
	},
	sectors: {
		add: 'Novo Setor',
		edit: 'Editar Setor',
		view: 'Informações do Setor',
	},
};

export const PROPERTY_SUBTITLES: Record<PropertyPageMode, Record<PropertiesTab, string>> = {
	add: {
		properties: 'Cadastre os dados gerais da nova propriedade',
		areas: 'Cadastre os dados gerais da nova área',
		sectors: 'Cadastre os dados técnicos do novo setor',
	},
	edit: {
		properties: 'Edite os dados gerais da propriedade',
		areas: 'Edite os dados gerais da área',
		sectors: 'Edite os dados técnicos do setor',
	},
	view: {
		properties: 'Visualize os dados gerais da propriedade',
		areas: 'Visualize os dados gerais da área',
		sectors: 'Visualize os dados técnicos do setor',
	},
};

export const PROPERTY_SECTION_TITLES: Record<PropertiesTab, string> = {
	properties: 'IDENTIFICAÇÃO',
	areas: 'IDENTIFICAÇÃO',
	sectors: 'INFORMAÇÕES GERAIS',
};

export const PROPERTY_CARD_TITLES: Record<PropertiesTab, string> = {
	properties: 'Informações Gerais',
	areas: 'Informações Gerais',
	sectors: 'Informações Técnicas',
};

export interface NextStepContent {
	title: string;
	subtitle: string;
	description: string;
	primaryLabel: string;
	nextType: 'areas' | 'sectors';
}

export const NEXT_STEP_CONTENT: Record<PropertiesTab, NextStepContent> = {
	properties: {
		title: 'Próximo passo!',
		subtitle: 'Cadastrar áreas',
		description:
			'Muito bem! Mas agora você precisa cadastrar uma nova área atrelada a esta propriedade para gerenciar a lavoura de café deste cliente.',
		primaryLabel: 'Cadastrar',
		nextType: 'areas',
	},
	areas: {
		title: 'Próximo passo!',
		subtitle: 'Cadastrar setores',
		description:
			'Perfeito! Mas agora, o último passo é cadastrar setor(es) atrelado a esta área que você acabou de criar.',
		primaryLabel: 'Cadastrar',
		nextType: 'sectors',
	},
	sectors: {
		title: 'Muito bem!',
		subtitle: 'Continuar ou voltar',
		description:
			'Você fez tudo certo! Você pode continuar cadastrando mais áreas e setores ou pode deixar para fazer isso depois. Você que sabe!',
		primaryLabel: 'Continuar',
		nextType: 'areas',
	},
};
